
export const ADMIN_ADD_ITEMS_REQ = "adminadditem";
export const ADMIN_ADD_ITEMS_SUC = "adminaddsuc";
export const ADMIN_ADD_ITEMS_ERR = "adminadderr";


export const ADMIN_GET_ITEMS_REQ = "admingetitem";
export const ADMIN_GET_ITEMS_SUC = "admingetsuc";
export const ADMIN_GET_ITEMS_ERR = "admingeterr";


export const ADMIN_DEL_ITEMS_REQ = "adminDELitem";
export const ADMIN_DEL_ITEMS_SUC = "adminDEL";
export const ADMIN_DEL_ITEMS_ERR = "adminDELerr";


export const ADMIN_UPDATE_REQ = "adminUPitem";
export const ADMIN_UPDATE_SUC = "adminUPSuc";
export const ADMIN_UPDATE_ERR = "adminUpdateErr";
 

